<div>
    <app-ativacao-section-card
        [control]="ativacaoControl"
        titulo="Crédito Presumido"
        descricaoAtivo="Crédito Presumido ativo. Os percentuais abaixo serão aplicados no cálculo desta regra tributária."
        descricaoInativo="Crédito Presumido inativo. Esta regra tributária não apura crédito presumido."
        emptyStateDescricao="Ative o Crédito Presumido acima para configurar os percentuais por operação, IBS e CBS.">
    </app-ativacao-section-card>

    @if (ativacaoControl.value) {
    <app-regra-tributaria-credito-presumido-operacao-section [form]="cpForm" [formulas]="formulasOperacao" [codigos]="codigosCreditoPresumido"></app-regra-tributaria-credito-presumido-operacao-section>
    <app-regra-tributaria-credito-presumido-ibs-section [form]="ibsForm" [formulas]="formulasIbs"></app-regra-tributaria-credito-presumido-ibs-section>
    <app-regra-tributaria-credito-presumido-cbs-section [form]="cbsForm" [formulas]="formulasCbs"></app-regra-tributaria-credito-presumido-cbs-section>
    }
</div>
